import { UserRole } from '@grcs/types/UserRole';
import { ProtectedRoute, ProtectedRouteProps } from './ProtectedRoute';

export const StudentProtectedRoute: React.FC<
  Pick<ProtectedRouteProps, 'children'>
> = ({ children }) => {
  return <ProtectedRoute access={UserRole.STUDENT}>{children}</ProtectedRoute>;
};
